/**
 * @generated SignedSource<<da1ac5eba04c96d49184ba8d01fd93ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetEmployeeLeaveItem_item$data = {
  readonly employee: {
    readonly id: string;
    readonly image: {
      readonly " $fragmentSpreads": FragmentRefs<"ImagePublicOrPrivate_image">;
    } | null;
    readonly name: string;
  };
  readonly id: string;
  readonly shifts: ReadonlyArray<{
    readonly endAt: string;
    readonly formattedEndAtTime: string;
    readonly formattedStartAtTime: string;
    readonly id: string;
    readonly leaveReason: {
      readonly id: string;
      readonly leaveCode: number;
      readonly leaveReason: string;
    } | null;
    readonly startAt: string;
  }>;
  readonly " $fragmentType": "WidgetEmployeeLeaveItem_item";
};
export type WidgetEmployeeLeaveItem_item$key = {
  readonly " $data"?: WidgetEmployeeLeaveItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeLeaveItem_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetEmployeeLeaveItem_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employee",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ImagePublicOrPrivate_image"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeShift",
      "kind": "LinkedField",
      "name": "shifts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formattedStartAtTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formattedEndAtTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LeaveReason",
          "kind": "LinkedField",
          "name": "leaveReason",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "leaveReason",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "leaveCode",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetEmployeeLeaveItem",
  "abstractKey": null
};
})();

(node as any).hash = "1d3b0e75cb977d31ac58d508d3cc1744";

export default node;
